import React, { useState, useCallback } from 'react'
import Announcement from '@groovehq/internal-design-system/lib/components/Announcement/Announcement'
import { styles } from '@groovehq/internal-design-system/lib/components/Announcement/Announcement.styles'
import NewLabel from '@groovehq/internal-design-system/lib/components/NewLabel/NewLabel'
import { heading } from '@groovehq/internal-design-system/lib/styles/elements'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import Video from 'components/VideoContainer/Video'
import { useDispatch, useSelector } from 'react-redux'
import { doSetFlag, selectFlag } from 'ducks/flags'
import { HIDE_ROADMAP_ANNOUNCEMENT } from 'ducks/flags/flagNames'

const videoId = 'e31palw96i'

const InboxAnnouncement = () => {
  const dispatch = useDispatch()
  const shouldHideAnnouncement = useSelector(state =>
    selectFlag(state)(HIDE_ROADMAP_ANNOUNCEMENT)
  )
  const [show, setShow] = useState(true)
  const handleCloseAnnouncement = useCallback(
    () => {
      dispatch(doSetFlag(HIDE_ROADMAP_ANNOUNCEMENT))
      setShow(false)
    },
    [dispatch]
  )
  if (shouldHideAnnouncement !== false) return null
  return (
    <Announcement.AnimatePresenceMotion open={show}>
      <Announcement.Modal onClose={handleCloseAnnouncement}>
        <div css={styles.bigImgWapper}>
          <Video videoId={videoId} />
        </div>
        <div className="grui text-center mt-14">
          <NewLabel />
          <h2 css={heading.styles.h2} className="grui mt-5">
            Our New Product Roadmap
          </h2>
          <p css={styles.bigCopy}>
            Check out our public roadmap to see our latest product upgrades and
            enhancements that are already live on your account, and get a sneak
            peek at the exciting new features that are coming soon!
          </p>
          <Button
            as="a"
            href="https://www.groovehq.com/our-roadmap"
            target="_blank"
            rel="noopener noreferrer"
            type="info"
            size="xBig"
            css={styles.btn}
            className="grui mr-5"
            onClick={handleCloseAnnouncement}
          >
            Take me to the Roadmap
          </Button>
        </div>
      </Announcement.Modal>
    </Announcement.AnimatePresenceMotion>
  )
}

export default InboxAnnouncement
